import endpoints from './endpoints.js'
import { replaceSpace } from './constants.js'
import httpClient from './httpClient'

// get payment methods
const getPaymentMethods = async (storeId, payload) => {
  return await httpClient.get(endpoints.STORES.PAYMENT_METHODS.replace(':storeId', replaceSpace(storeId)), {
    params: payload || undefined,
  })
}

// get donation items
const getDonationItems = async (storeId, serviceTypeId, orderId) => {
  return await httpClient.get(
    endpoints.STORES.DONATION_ITEMS.replace(':storeId', replaceSpace(storeId))
      .replace(':serviceTypeId', serviceTypeId)
      .replace(':orderId', orderId)
  )
}

// get stores
const getStores = async (payload) => {
  return await httpClient.get(endpoints.STORES.STORES, { params: payload || undefined })
}

// get single store
const getStore = async (storeId, payload) => {
  const endpoint = storeId
    ? endpoints.STORES.STORE.replace(':storeId', replaceSpace(storeId))
    : endpoints.STORES.STORE_NO_ID

  return await httpClient.get(endpoint, { params: payload || undefined })
}

// get configuration
const getConfiguration = async () => {
  return await httpClient.get(endpoints.STORES.CONFIG)
}

// get branding
const getBranding = async () => {
  return await httpClient.get(endpoints.STORES.BRANDING)
}

// get app branding
const getAppBranding = async () => {
  return await httpClient.get(endpoints.STORES.APP_BRANDING)
}

export default {
  getPaymentMethods,
  getDonationItems,
  getStores,
  getStore,
  getConfiguration,
  getBranding,
  getAppBranding,
}
